const mui = {
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.shadows[0],
        backgroundColor: "transparent",
        backgroundImage: "none",
        position: "relative",
        borderBottom: `1px solid ${theme.palette.background.paper}`,
      }),
    },
  },
};
export default mui;
